import { toast } from "react-toastify";
import fetchData from "../custom_functions/fetchData";
import Table from "../reusable_components/Table";
import { url } from "../utils/config";
import { btnGreen, btnRed, title } from "../utils/style";
import moment from "moment";


function CertificationRequest() {

    function approveCertificationRequest(id) {
        const reqUrl = url + `/approve_certification_request/${id}`;
        fetchData(reqUrl, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }, (data) => {
            toast.success(data.message, { autoClose: 3000 })
        })
    }

    function rejectCertificationRequest(id) {
        const reqUrl = url + `/reject_certification_request/${id}`;
        fetchData(reqUrl, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }, (data) => {
            toast.success(data.message, { autoClose: 3000 })
        })
    }

    const options = [
        {
            header: 'REQUESTED BY',
            key: 'requestedBy'
        },
        {
            header: 'COURSE NAME',
            key: 'name'
        },
        {
            header: 'DATE',
            key: 'requestDate',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'DURATION',
            key: 'duration'
        },
        {
            header: 'ACTION',
            render: (data) => {
                return(
                    <>
                        <button 
                            className={btnGreen}
                            onClick={() => approveCertificationRequest(data.id)}
                        >
                            Approve
                        </button>
                        <button 
                            className={btnRed}
                            onClick={() => rejectCertificationRequest(data.id)}
                        >
                            Reject
                        </button>
                    </>
                )
            }
        }
    ]

    const excludeFilter = ['ACTION']

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Certification Requests</div>
            <Table 
                options={ options } 
                url={ url + '/certification_requests'} 
                pagination 
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default CertificationRequest;